module.exports = __webpack_public_path__ + "static/contacts-1.8f827db5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/contacts/contacts-1.svg
// module id = 284
// module chunks = 153124696304688 200084577921036